import React, { useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { url } from "../../../Constant";
import { useEffect } from "react";
import { useAuth } from "../../../Context/AuthProvider";
import { toast } from "react-toastify";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../../Utils/PermissionFunctions";
import { useNavigate } from "react-router-dom";

const Prompts = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [extensionData, setExtensionData] = useState();
  const [apicalled, setApicalled] = useState(false);
  const [loader, setLoader] = useState(false);
  const { auth } = useAuth();
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const columns = [
    {
      name: "File Name",
      selector: (row) => row,
    },
    {
      name: "STATUS",
      // selector: (row) => row.status,
      selector: (row) => (
        <div>
          <button
            className={"btn-design redColor"}
            onClick={() => deleteFile(row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const handleStatusUpdate = (data, type) => {
    let dataForApi = {
      vpbx_id: auth.vpbx_id,
      extension: data.extension_number,
    };

    if (type === "inbound") {
      dataForApi["inbound_status"] = data.is_inbound == 1 ? 0 : 1;
    }
    if (type === "outbound") {
      dataForApi["outbound_status"] = data.is_outbound == 1 ? 0 : 1;
    }
    let api = "";
    if (auth.role === "2") {
      api = "update-extension-status";
    } else {
      api = "user-update-extension-status";
    }
    axios
      .post(url + api, dataForApi, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(function (result) {
        if (result.data.code === 200) {
          setTimeout(() => {
            toast.success("Extension status Changed Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 500);
          setTimeout(() => {
            getPrompts();
          }, 700);
        } else {
          setTimeout(() => {
            toast.error(result.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1200,
            });
          }, 1500);
        }
      });
  };

  const deleteFile = (file) => {
    setLoader(true);
    axios
      .post(
        url + "/delete-prompt",
        {
          vpbx_id: auth.vpbx_id,
          file_name: file,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.data.status === true) {
              setTimeout(() => {
                // setLoader(false);
                toast.success("Sound deleted successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1000,
                });
              }, 200);
              setTimeout(() => {
                getPrompts();
              }, 500);
              // AudioForm();
              //   window.location.reload();
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getPrompts = () => {
    setLoader(true);

    axios
      .post(
        url + "prompt-list",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.data.code === 200) {
            setLoader(false);

            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setExtensionData([]);
            } else if (response.data.message === "Data Found") {
              setExtensionData(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
          setLoader(false);
        }
      );
  };

  useEffect(() => {
    getPrompts();
  }, []);
  useEffect(() => {
    if (apicalled === true) {
      getPrompts();
    }
  }, [apicalled]);
  const filteredData = extensionData?.filter((val) => {
    return (
      val &&
      typeof val === "string" &&
      val.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  useEffect(() => {
    if (extensionData !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)"
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [extensionData]);
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>
            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("ivr-flow") ? (
                      <li
                        onClick={() => navigate("/ivr-flow", { replace: true })}
                      >
                        <a href="#">IVR flow</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("extensions") ? (
                      <li
                        onClick={() =>
                          navigate("/extensions", { replace: true })
                        }
                      >
                        <a href="#">Extensions</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("Forwarding") ? (
                      <li
                        onClick={() =>
                          navigate("/call-forwarding", { replace: true })
                        }
                      >
                        <a href="#">Forwarding</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("conferencing") ? (
                      <li
                        onClick={() =>
                          navigate("/call-conferencing", { replace: true })
                        }
                      >
                        <a href="#">Conferencing</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("list-manager") ? (
                      <li
                        onClick={() =>
                          navigate("/list-manager", { replace: true })
                        }
                      >
                        <a href="#">List manager</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("hours") ? (
                      <li onClick={() => navigate("/hour", { replace: true })}>
                        <a href="#">Hours</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("queue") ? (
                      <li onClick={() => navigate("/queue", { replace: true })}>
                        <a href="#">Queue</a>
                      </li>
                    ) : null}
                    {auth.role === "2" ? (
                      <li
                        className="uk-active"
                        onClick={() => navigate("/prompt", { replace: true })}
                      >
                        <a href="#">prompt</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("ivr-flow") ? (
                  <li onClick={() => navigate("/ivr-flow")}></li>
                ) : null}

                {auth.role === "2" || checkPermissions("extensions") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("Forwarding") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("conferencing") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("list-manager") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("hours") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("queue") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" ? (
                  <li>
                    <div className="ImcomingCallMain RoutingMain">
                      <div className="uk-grid" uk-grid="">
                        <div className="uk-width-1-1">
                          <div className="uk-text-left">
                            <div className="MainHeading">
                              <h6>Prompts </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        {loader ? (
                          <div uk-spinner="" className="tableloader"></div>
                        ) : (
                          <DataTable
                            columns={columns}
                            data={filteredData}
                            pagination
                          />
                        )}
                      </div>
                    </div>
                  </li>
                ) : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Prompts;
